<template>
  <notifications :duration="5000" :max="5" :width="520">
    <template slot="body" slot-scope="{ item, close }">
      <div class="vue-notification toast">
        <div class="toast__icon" :class="[item.type]">
          <SvgIcon :name="getIcon(item)" />
        </div>
        <div class="toast__content">
          <div class="toast__head">
            <div class="toast__title">{{ item.title }}</div>
            <div class="toast__tag" v-if="item.data && item.data.tag">{{ item.data.tag }}</div>
          </div>
          <div class="toast__text" v-html="item.text" />
        </div>
        <div class="toast__actions">
          <div class="toast__close" @click="close">
            <SvgIcon name="close" />
          </div>
        </div>
      </div>
    </template>
  </notifications>
</template>

<script>
import { withUi } from '@/components/ui'

export default {
  mixins: [withUi],
  methods: {
    getIcon(item) {
      if (item.data && item.data.icon) {
        return item.data.icon
      }

      if (item.type) {
        if (item.type === 'error') {
          return 'close'
        }
      }

      return 'notify'
    },
  },
}
</script>

<style lang="scss">
.vue-notification-group {
  padding-top: 28px;
  padding-right: 28px;
  pointer-events: none;
}

.vue-notification-wrapper {
  overflow: visible !important;
}

.vue-notification {
  &.toast {
    display: flex !important;
    align-items: center;
    margin: 0 0 10px;
    padding: 22px 0px 22px 30px;
    background: #ffffff;
    box-shadow: -3px 18px 87px -4px rgba(0, 0, 0, 0.1);
    border-left: 0;
    border-radius: 10px;
    color: $text;
    pointer-events: all;
  }
}

.toast {
  &__icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 35px;
    height: 35px;
    background: $primary;
    border-radius: 5px;
    color: white;
    &.success {
      background: $green;
    }
    &.error {
      background: #e9272b;
    }
    &.info {
      background: $primary;
    }
  }
  &__content {
    flex: 1 1 auto;
    padding-left: 22px;
    padding-right: 12px;
  }
  &__head {
    display: flex;
    align-items: center;
  }
  &__title {
    font-weight: bold;
    font-size: 14px;
    line-height: 1.47;
    padding-right: 6px;
  }
  &__tag {
    background: $bg;
    padding: 3px 7px;
    border-radius: 3px;
    font-size: 12px;
    line-height: (15 / 12);
    color: $dark;
  }
  &__text {
    margin-top: 3px;
    font-size: 12px;
    line-height: 1.78;
    color: $dark;
  }

  &__actions {
    flex: 0 0 auto;
  }
  &__close {
    font-size: 0;
    cursor: pointer;
    color: $dark;
    padding: 22px 20px 22px 10px;
    transition: color 0.25s $ease;
    .svg-icon {
      font-size: 18px;
    }
    &:hover {
      color: $primary;
    }
  }
}

@include mobile {
  .vue-notification-group {
    padding-top: 72px;
    padding-right: 20px;
    width: 100 !important;
    max-width: 295px;
  }

  .vue-notification {
    &.toast {
      padding: 18px 0 18px 18px;
      align-items: flex-start;
    }
  }

  .toast {
    &__content {
      flex: 1 1 auto;
      padding-left: 15px;
      padding-right: 12px;
    }
    &__head {
      display: block;
    }
    &__title {
      display: inline;
      font-size: 12px;
    }
    &__tag {
      display: inline;
      font-size: 10px;
    }
    &__text {
      margin-top: 10px;
      margin-left: -47px;
    }

    &__actions {
      flex: 0 0 auto;
    }
    &__close {
      font-size: 0;
      cursor: pointer;
      color: $dark;
      margin-top: -18px;
      padding: 18px 18px 10px 10px;
      transition: color 0.25s $ease;
      .svg-icon {
        font-size: 18px;
      }
    }
  }
}
</style>
